import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { getId } from '../../utils/item';
import { deepCloneObject } from '../../utils/object';
import { TooltipHtml } from '../tooltip/tooltip.Html';
import { TextareaAutosize } from '@mui/material';

export const ConditionSettingsDisplayField = props => {
  const { fieldId, itemId, updateInState, condition, state } = props;

  const fieldInCondition = condition?.[state]?.fields?.[fieldId] || {};
  const itemField = useSelector(state => state.items[itemId]);
  const objFieldInItem = itemField?.[fieldInCondition?.type]?.find(
    objNum => getId(objNum) === fieldId
  );
  const fieldValueInCondition =
    condition?.[state]?.fields?.[fieldId]?.value ?? '';
  const [fieldValue, setFieldValue] = useState(fieldValueInCondition);

  useEffect(() => {
    setFieldValue(fieldValueInCondition);
  }, [fieldValueInCondition]);

  const deleteField = fieldId => {
    const clonedCondition = deepCloneObject(condition);
    let clonedFields = deepCloneObject(clonedCondition[state].fields);
    delete clonedFields[fieldId];
    updateInState(clonedFields, 'fields');
  };

  return (
    <div className='flex items-center gap-1'>
      <div
        onDoubleClick={e => {
          e.stopPropagation();
          deleteField(fieldId);
        }}
        className='text-secondary cursor-pointer transition opacity-50 hover:opacity-100'
      >
        <FaTimes />
      </div>
      {objFieldInItem?.[fieldId]?.label}
      {fieldInCondition?.type === 'has_num' && (
        <div className='flex items-center gap-02 text-3xs uppercase text-contrast text-opacity-60'>
          {[
            { key: 'value', label: 'Valeur' },
            { key: 'mod', label: 'Mod' },
          ].map(option => {
            const current =
              condition?.[state]?.fields?.[fieldId]?.target || 'value';
            const isActive = current === option.key;
            return (
              <div
                key={option.key}
                className={`px-03 py-01 rounded cursor-pointer border transition ${
                  isActive
                    ? 'bg-primary text-contrast border-primary'
                    : 'bg-main text-contrast text-opacity-60 border-main'
                }`}
                onClick={() =>
                  updateInState(option.key, 'fields', fieldId, 'target')
                }
              >
                {option.label}
              </div>
            );
          })}
        </div>
      )}
      <TooltipHtml
        title={['=', '+', '-', '*', '/'].map(symbole => (
          <div
            onClick={() => updateInState(symbole, 'fields', fieldId, 'symbole')}
            className='text-contrast text-lg font-bold text-center transition cursor-pointer hover:opacity-50'
          >
            {symbole}
          </div>
        ))}
      >
        <div>{condition?.[state]?.fields?.[fieldId]?.symbole}</div>
      </TooltipHtml>

      <TextareaAutosize
        minRows={1}
        className='rounded bg-main bg-opacity-50 text-contrast text-opacity-80 flex-1 m-1 px-1 py-05 resize-y'
        placeholder={'valeur ou formule'}
        value={fieldValue}
        onChange={e => setFieldValue(e.target.value)}
        onBlur={() => updateInState(fieldValue, 'fields', fieldId, 'value')}
      />
    </div>
  );
};
